var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('vue-particles',{key:_vm.particleKey,staticClass:"vue-particles-background",attrs:{"color":"#dedede"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }